const PartnersSection = () => {
  const partners = Array(6).fill(null);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Referral Network
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Carefully selected partners who share our commitment to excellence in cybersecurity and compliance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partners.map((_, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg border border-gray-200 p-8 hover:shadow-lg transition-shadow duration-300"
            >
              {/* Logo Placeholder */}
              <div className="mb-6">
                <div className="w-full h-32 bg-gray-100 rounded-lg flex items-center justify-center border-2 border-dashed border-gray-300">
                  <div className="text-center">
                    <i className="ri-image-line text-4xl text-gray-400 mb-2"></i>
                    <p className="text-sm text-gray-500 font-medium">Partner Logo</p>
                  </div>
                </div>
              </div>

              {/* Partner Name */}
              <div className="mb-4">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                  Partner Name
                </label>
                <div className="h-8 bg-gray-50 rounded border border-gray-200 flex items-center px-3">
                  <span className="text-sm text-gray-400 italic">Enter partner name</span>
                </div>
              </div>

              {/* Description */}
              <div className="mb-4">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                  Description
                </label>
                <div className="min-h-[80px] bg-gray-50 rounded border border-gray-200 p-3">
                  <p className="text-sm text-gray-400 italic">Description coming soon.</p>
                </div>
              </div>

              {/* Services Provided */}
              <div className="mb-6">
                <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                  Services Provided
                </label>
                <div className="min-h-[60px] bg-gray-50 rounded border border-gray-200 p-3">
                  <p className="text-sm text-gray-400 italic">Services coming soon.</p>
                </div>
              </div>

              {/* Website Button Placeholder */}
              <button 
                className="w-full py-3 px-4 bg-gray-100 text-gray-400 rounded-lg font-medium text-sm border border-gray-200 cursor-not-allowed whitespace-nowrap"
                disabled
              >
                <i className="ri-external-link-line mr-2"></i>
                Visit Website
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
